<div class="card shadow mb-4 h-100">
  <div class="card-header">
    <div class="d-flex justify-content-between align-items-center" style="height: 40px">
      <div>
        <h3>{{ "Case Creditor details" | translate }}</h3>
      </div>
      <div *ngIf="!isEditing" class="col-5 text-right">
        <button mat-icon-button color="primary" (click)="toggleEditMode()" class=" p-0">
          <mat-icon>settings</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="card-body pt-0">
    <app-server-response [response]="serverResponse"></app-server-response>
    <div class="pt-4 pl-4" *ngIf="isLoading">
      <mat-spinner class="m-0 m-auto"></mat-spinner>
    </div>
    <form *ngIf="form" [hidden]="isLoading" [formGroup]="form" (ngSubmit)="submitForm()">
      <div>
        <mat-tab-group mat-align-tabs="start" [selectedIndex]="0" [class.single-case]="!case?.joint_application">
          <mat-tab [label]="'CASES.single.general.client_editor.tabs.client' | translate">
            <div class="disabled-form">
                <!-- Ref Number -->
                <app-input formControlName="ref_number" [label]="'CASE_CREDITOR.model.reference_number' | translate"
                           [showLabel]="false" [extraLabel]="true" appearance="outline" [fullWidth]="true"
                           flexClass="align-items-center">
                </app-input>
              <!-- Creditor Name -->
              <app-input formControlName="creditor_name" [label]="'CASE_CREDITOR.model.name' | translate"
                         [showLabel]="false" [extraLabel]="true" appearance="outline" [fullWidth]="true"
                         flexClass="align-items-center">
              </app-input>
              <!-- Original balance -->
              <app-input formControlName="initial_balance" [label]="'CASE_CREDITOR.model.original_balance' | translate"
                         [showLabel]="false" [extraLabel]="true" appearance="outline" [fullWidth]="true"
                         flexClass="align-items-center">
              </app-input>
              <!-- Negotiated balance -->
              <app-input formControlName="negotiated_amount" [label]="'CASE_CREDITOR.model.negotiated_amount' | translate"
                         [showLabel]="false" [extraLabel]="true" appearance="outline" [fullWidth]="true"
                         flexClass="align-items-center">
              </app-input>
              <!-- Reduction -->
              <app-input formControlName="reduction" [label]="'CASE_CREDITOR.model.reduction' | translate"
                         [showLabel]="false" [extraLabel]="true" appearance="outline" [fullWidth]="true"
                         flexClass="align-items-center">
              </app-input>
              <!-- Date of update -->
              <div class="row mt-2 mb-2">
                <div class="col">{{ 'CASE_CREDITOR.days_of_update' | translate }}</div>
                <div class="col">{{caseCreditor.negotiated_amount_updated_at | date:'short'}}</div>
              </div>
              <!-- Date in status -->
              <app-input formControlName="days_in_status" [label]="'CASE_CREDITOR.days_in_status' | translate"
                         [showLabel]="false" [extraLabel]="true" appearance="outline" [fullWidth]="true"
                         flexClass="align-items-center">
              </app-input>
              <!-- Fund available -->
              <app-input formControlName="available_funds" [label]="'Fund available' | translate"
                         [showLabel]="false" [extraLabel]="true" appearance="outline" [fullWidth]="true"
                         flexClass="align-items-center">
              </app-input>
              <!-- Expected Fee -->
              <app-input formControlName="expected_fee" [label]="'Expected Fee' | translate"
                         [showLabel]="false" [extraLabel]="true" appearance="outline" [fullWidth]="true"
                         flexClass="align-items-center">
              </app-input>
            </div>
          </mat-tab>
          <!-- <mat-tab [label]="'CASES.single.general.client_editor.tabs.partner' | translate"
                   *ngIf="this.case.joint_application">
            <div class="disabled-form" formGroupName="partner">
              &lt;!&ndash; Partner First Name &ndash;&gt;
              <app-input formControlName="first_name" [label]="'USERS.model.first_name' | translate"
                         [showLabel]="false" [extraLabel]="true" appearance="outline" [fullWidth]="true"
                         flexClass="align-items-center">
              </app-input>
              &lt;!&ndash; Partner Last Name &ndash;&gt;
              <app-input formControlName="last_name" [label]="'USERS.model.last_name' | translate"
                         [showLabel]="false" [extraLabel]="true" appearance="outline" [fullWidth]="true"
                         flexClass="align-items-center">
              </app-input>
              &lt;!&ndash; Partner Email &ndash;&gt;
              <app-input type="email" formControlName="email" [label]="'USERS.model.email' | translate"
                         [showLabel]="false" [extraLabel]="true" appearance="outline" [fullWidth]="true"
                         flexClass="align-items-center">
              </app-input>
              &lt;!&ndash; Partner Phone &ndash;&gt;
              <div>
                <app-input type="number" formControlName="phone" [label]="'USERS.model.phone' | translate"
                           [showLabel]="false" [extraLabel]="true" appearance="outline" [fullWidth]="false"
                           flexClass="align-items-center">
                </app-input>
                <div class="d-flex flex-row justify-content-center align-items-center"
                     *ngIf="!isEditing && case.partner.phone !== null" class="blue-text"
                     style="position: absolute;right: 0px;top: 151px;cursor: pointer">
                  <mat-icon aria-hidden="false" class="mr-3" (click)="clickToCall('phone', 'partner')">call
                  </mat-icon>
                </div>
              </div>
              &lt;!&ndash;Partner Home phone&ndash;&gt;
              <div>
                <app-input type="number" formControlName="home_phone" [label]="'USERS.model.home_phone' | translate"
                           [showLabel]="false" [extraLabel]="true" appearance="outline" [fullWidth]="false"
                           flexClass="align-items-center">
                </app-input>
                <div class="d-flex flex-row justify-content-center align-items-center"
                     *ngIf="!isEditing && case.partner.home_phone !== null" class="blue-text"
                     style="position: absolute;right: 0px;top: 186px;cursor: pointer">
                  <mat-icon aria-hidden="false" class="mr-3" (click)="clickToCall('home_phone', 'partner')">call
                  </mat-icon>
                </div>
              </div>
              &lt;!&ndash;Partner Work phone&ndash;&gt;
              <div>
                <app-input type="number" formControlName="work_phone" [label]="'USERS.model.work_phone' | translate"
                           [showLabel]="false" [extraLabel]="true" appearance="outline" [fullWidth]="false"
                           flexClass="align-items-center">
                </app-input>
                <div class="d-flex flex-row justify-content-center align-items-center"
                     *ngIf="!isEditing && case.partner.work_phone !== null" class="blue-text"
                     style="position: absolute;right: 0px;top: 221px;cursor: pointer">
                  <mat-icon aria-hidden="false" class="mr-3" (click)="clickToCall('work_phone', 'partner')">call
                  </mat-icon>
                </div>
              </div>
              &lt;!&ndash; Partner ID Card &ndash;&gt;
              <app-input formControlName="id_card" [label]="'USERS.model.id_card' | translate"
                         [showLabel]="false" [extraLabel]="true" appearance="outline" [fullWidth]="true"
                         flexClass="align-items-center">
              </app-input>
              &lt;!&ndash; Partner Address &ndash;&gt;
              <div formGroupName="address">
                &lt;!&ndash; Partner Address 1 &ndash;&gt;
                <app-input formControlName="address_1" [label]="'ADDRESS.address_1' | translate"
                           [showLabel]="false" [extraLabel]="true" appearance="outline" [fullWidth]="true"
                           flexClass="align-items-center">
                </app-input>
                &lt;!&ndash; Partner Address 2 &ndash;&gt;
                <app-input formControlName="address_2" [label]="'ADDRESS.address_2' | translate"
                           [showLabel]="false" [extraLabel]="true" appearance="outline" [fullWidth]="true"
                           flexClass="align-items-center">
                </app-input>
              </div>
            </div>
            <button mat-button color="primary" mat-raised-button class="mt-2" type="button"
                    [disabled]="!isElementRestricted()" (click)="openUserPasswordModal(case.partner.id)">
              {{ 'USERS.editor.change-user-password' | translate }}
            </button>
          </mat-tab> -->
        </mat-tab-group>
      </div>
      <div *ngIf="isEditing" class="row pt-3">
        <div class="col-12 text-right">
          <button mat-button color="primary" class="mr-3" (click)="toggleEditMode()">
            {{ 'SHARED.cancel' | translate }}
          </button>
          <app-spinner-btn type="submit" [disabled]="!isElementRestricted()" [loading]="isSubmitting" color="primary">
            {{ 'SHARED.save' | translate }}
          </app-spinner-btn>
        </div>
      </div>
    </form>
  </div>
</div>
